import * as React from 'react';
import { View } from './view';
import { useViewModel } from './viewModel';

export default function Dashboard() {
  const viewModel = useViewModel();
  return <View {...viewModel} />;
}

